module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_56.25deg.78df2cc6.png";